import React from "react";

const TopPartners = () => {
  const partners_list = [
    { src: "https://ik.imagekit.io/abkvohwfl/kyberswap_DqA6wZuIMe.png", title: "KyberSwap" },
    { src: "https://ik.imagekit.io/abkvohwfl/Uniswap_Logo_QYg2jUWwiN.png", title: "Uniswap" },
    { src: "https://ik.imagekit.io/abkvohwfl/Enzyme_sMEZkQxZlL.png", title: "Enzyme" },
    { src: "https://ik.imagekit.io/abkvohwfl/Polygon_blockchain_logo_Bq-uivBej.png", title: "Polygon" },
    { src: "https://ik.imagekit.io/abkvohwfl/hardhat_iQJzkQpGo.png", title: "Hardhat" },
  ];

  return (
    <div className="partner-area pb-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-title text-center mb-10">
              <span className="sub-title">Nossos Parceiros</span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="partner-wrap">
              <ul>
                {partners_list.map((item, index) => (
                  <li key={index}>
                    <img src={item.src} alt={item.title} />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopPartners;
